'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var Radio = _react2['default'].createClass({
  displayName: 'Radio',

  contextTypes: {
    radioGroup: _react2['default'].PropTypes.object
  },

  render: function render() {
    var _context$radioGroup = this.context.radioGroup;
    var name = _context$radioGroup.name;
    var selectedValue = _context$radioGroup.selectedValue;
    var onChange = _context$radioGroup.onChange;

    var optional = {};
    if (selectedValue !== undefined) {
      optional.checked = this.props.value === selectedValue;
    }
    if (typeof onChange === 'function') {
      optional.onChange = onChange.bind(null, this.props.value);
    }

    return _react2['default'].createElement('input', _extends({}, this.props, {
      type: 'radio',
      name: name
    }, optional));
  }
});

exports.Radio = Radio;
var RadioGroup = _react2['default'].createClass({
  displayName: 'RadioGroup',

  propTypes: {
    name: _react.PropTypes.string,
    selectedValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.bool]),
    onChange: _react.PropTypes.func,
    children: _react.PropTypes.node.isRequired,
    Component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.object])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      Component: "div"
    };
  },

  childContextTypes: {
    radioGroup: _react2['default'].PropTypes.object
  },

  getChildContext: function getChildContext() {
    var _props = this.props;
    var name = _props.name;
    var selectedValue = _props.selectedValue;
    var onChange = _props.onChange;

    return {
      radioGroup: {
        name: name, selectedValue: selectedValue, onChange: onChange
      }
    };
  },

  render: function render() {
    var _props2 = this.props;
    var Component = _props2.Component;
    var name = _props2.name;
    var selectedValue = _props2.selectedValue;
    var onChange = _props2.onChange;
    var children = _props2.children;

    var rest = _objectWithoutProperties(_props2, ['Component', 'name', 'selectedValue', 'onChange', 'children']);

    return _react2['default'].createElement(
      Component,
      rest,
      children
    );
  }
});
exports.RadioGroup = RadioGroup;


//////////////////
// WEBPACK FOOTER
// ./~/react-radio-group/lib/index.js
// module id = 1243
// module chunks = 0